export const TYPES = {
  SINGLE_LABEL: 'single_label',
  DEFAULT: 'default',
};
